import type { StructuralDecorator } from "../decorator.js";
import type { GroupKeyOf, ItemKeyOf, ModulesOf, TypedBy } from "../typedBy.js";

/**
 * An order for the form, as `Order` describes, naming only keys the modules
 * it is typed by ask: typed by every supported version, it can name a key
 * only an older one asks.
 */
export const formOrder = <Typing extends TypedBy>(
  _typedBy: Typing,
  order: {
    groups: readonly GroupKeyOf<ModulesOf<Typing>>[];
    items: readonly ItemKeyOf<ModulesOf<Typing>>[];
  },
): StructuralDecorator => ({ kind: "structural", form: () => order });
